<template>
    <transition name="fade" mode="out-in" :appear="appear">
      <slot />
    </transition>
</template>

<script>
export default {
  name: 'FadeTransition',
  props: {
    appear: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  @keyframes fade {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  .fade-enter-active {
    animation: fade 400ms ease-in-out reverse;
  }

  .fade-leave-active {
    animation: fade 400ms ease-in-out;
  }
</style>
